import { render, staticRenderFns } from "./Webphone.vue?vue&type=template&id=57b82c60&scoped=true"
import script from "./Webphone.vue?vue&type=script&lang=js"
export * from "./Webphone.vue?vue&type=script&lang=js"
import style0 from "./Webphone.vue?vue&type=style&index=0&id=57b82c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b82c60",
  null
  
)

export default component.exports